import { ListChecks } from "lucide-react";
import type { LineageNode } from "../types";
import { NodeShell } from "./NodeShell";

interface Props {
  data: LineageNode;
  selected?: boolean;
}

export function ScreeningCriteriaNode({ data, selected }: Props) {
  return <NodeShell node={data} icon={ListChecks} selected={selected} />;
}
